module.exports = __webpack_public_path__ + "assets/webgl/LM.2.jpg.5a39f467.webp";